import React, { useState, useEffect, useId } from "react";
import axios from "axios";
import { useForm } from "react-hook-form";
import { FaRegCheckCircle, FaCheck } from "react-icons/fa";

export default function Form() {
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm();

    const ubdCheckboxId = useId();
    const airAlertCheckboxId = useId();
    
    // Функція для отримання значення з cookie
    const getCookie = (cookieName) => {
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArr = decodedCookie.split(';');
        for (let i = 0; i < cookieArr.length; i++) {
            let cookie = cookieArr[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(name) === 0) {
                return cookie.substring(name.length, cookie.length);
            }
        }
        return "";
    };

    const currentPath = window.location.pathname;
    const isEn = currentPath.startsWith("/en");

    const [preloader, preloaderFormStyle] = useState("hidden");
    const [promoAlert, setPromoAlertData] = useState("");
    const [promoAlertStyle, setPromoAlerStyle] = useState("");

    const [event, setEvent] = useState({});

    const errorStyle =
        "absolute -top-2 right-0 text-red-800 z-10 bg-white text-[13px] px-[4px] leading-none rounded-r flex items-center";
    const successStyle =
        "absolute top-0 right-0 text-[#003366] z-10 text-sm h-full p-[4px] leading-none rounded-full flex items-center";

    const domain = window.location.protocol + "//" + window.location.host;

    const inputStyle = "font-medium text-base text-[#245864] appearance-none border-[1px] border-x-0 border-t-0 border-b-[#245864] w-full pb-4 placeholder:text-[#245864] bg-transparent"

    const clearDataPromo = async (data) => {
        var promocodeData = {
            promocode: data,
            site_name: domain,
            action: "checkpromo",
        };

        try {
            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-forms-handler-dev/handler.php?event_id=4510",
                promocodeData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.status === 201 || response.status === 200) {
                if (response.data.check === false) {
                    setPromoAlertData(response.data.message);
                    setPromoAlerStyle(errorStyle);
                } else {
                    setPromoAlertData(<FaCheck />);
                    setPromoAlerStyle(successStyle);
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const onSubmit = async (data) => {
        try {
            preloaderFormStyle("flex");

            // Надіслати подію в GTM
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'form_send',
                formType: 'Contact',
            });

            const response = await axios.post(
                "https://ekonomika.ua/wp-content/plugins/ekonomika-forms-handler-dev/handler.php?event_id=4510",
                data,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.data.check !== false) {
                window.location.href = response.data;
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            preloaderFormStyle("hidden");
        }
    };

    const normalizeTel = (value) => {
        value = value.replace(/\D/g, "");
        value = value.replace(/^(\d{3})(\d)/g, "($1) $2");
        if (value.length < 14) {
            value = value.replace(/(\d{3})(\d{2})(\d{2})$/, "$1-$2-$3");
        } else {
            value = value.replace(/(\d{3})(\d{2})(\d{2})(\d{2})$/, "$1-$2-$3-$4");
        }
        return value;
    };

    // URL params
    const windowUrl = window.location.search;
    const searchParams = new URLSearchParams(windowUrl);

    const utm_source = searchParams.get("utm_source") || "";
    const utm_medium = searchParams.get("utm_medium") || "";
    const utm_campaign = searchParams.get("utm_campaign") || "";
    const utm_content = searchParams.get("utm_content") || "";

    // Translated texts
    const priceNote = isEn ? "* Price before tax" : "* Ціна до оподаткування";
    const emailError = isEn ? "enter email" : "вкажіть email";
    const phoneError = isEn ? "enter phone" : "вкажіть телефон";
    const submitText = isEn ? "Submit" : "Надіслати";
    const waitText = isEn ? "Please wait..." : "Зачекайте...";
    const price = isEn ? "uah" : "грн";

    useEffect(() => {
        setValue("user_agent", navigator.userAgent);

        // Зчитування cookie _fbc та _fbp
        const fbc = getCookie("_fbc");
        const fbp = getCookie("_fbp");
        if (fbc) setValue("fbc", fbc);
        if (fbp) setValue("fbp", fbp);

        // Отримання IP-адреси за допомогою зовнішнього API
        const fetchIpAddress = async () => {
            try {
                const response = await axios.get("https://api.ipify.org?format=json"); // Використовуємо ipify API
                setValue("user_ip", response.data.ip);
            } catch (error) {
                console.error("Не вдалося отримати IP-адресу: ", error);
                setValue("user_ip", "");
            }
        };

        fetchIpAddress();
    }, [setValue]);

    return (
        <div className="flex-1">
            <form onSubmit={handleSubmit(onSubmit)} className="mb-6">

                {/* <div className="mb-4 relative">
                    <input
                        type="text"
                        name="fullName"
                        {...register("fullName", { required: true })}
                        placeholder="Прізвище та ім’я"
                        className={inputStyle}
                    />
                    {errors.fullName && <div className={errorStyle}>Вкажіть прізвище та ім’я</div>}
                </div> */}

                <div className="mb-4 relative">
                    <input
                        type="email"
                        name="email"
                        {...register("email", {required: true})}
                        placeholder={isEn ? "Email" : "Пошта"}
                        className={inputStyle}
                    />
                    {errors.email && <div className={errorStyle}>{emailError}</div>}
                </div>

                <div className="mb-4 relative ">
                    <input
                        type="text"
                        {...register("phone", {
                            required: true,
                            pattern:
                                /^\([0-9]{3}\) [0-9]{2,5}-[0-9]{2,5}-[0-9]{2,5}/,
                        })}
                        maxLength="17"
                        placeholder={isEn ? "Phone (099) 999-99-99" : "Тел. (099) 999-99-99"}
                        onChange={(event) => {
                            const {value} = event.target;
                            event.target.value = normalizeTel(value);
                        }}
                        name="phone"
                        className={inputStyle + " " + (errors.phone ? "form-control text-amber-700" : "form-control")}
                    />
                    {errors.phone && (
                        <div className={errorStyle}>{phoneError}</div>
                    )}
                </div>

                {/*<div className="relative rounded h-max mb-9 ">
                    <input
                        type="text"
                        {...register("promocode")}
                        name="promocode"
                        placeholder={isEn ? "Promo code" : "Промокод"}
                        onBlur={(event) => {
                            const {value} = event.target;
                            clearDataPromo(value);
                        }}
                        className={inputStyle}
                    />
                    {promoAlert ? <div className={promoAlertStyle}>{promoAlert}</div> : null}
                </div>*/}

                <div className="mb-[12px] flex items-center gap-3">
                    <input type="checkbox" id={ubdCheckboxId}
                        {...register("ubd")}
                        value="ubd"
                        className="appearance-none relative block w-4 h-4 shrink-0 
                         bg-[rgba(245,216,88,0.2)] border border-black cursor-pointer checked:bg-black checked:border-black after:absolute after:left-1/2 after:top-1/2 after:h-2 after:w-1 after:-translate-x-1/2 after:-translate-y-1/2 after:rotate-45 after:border-b-2 after:border-r-2 after:border-white after:opacity-0 checked:after:opacity-100"
                    />
                    <label htmlFor={ubdCheckboxId} className="text-[12px] font-medium cursor-pointer select-none underline">Маю посвідчення УБД<span className="text-red-600">*</span></label>
                </div>
                <div className="mb-[20px] flex items-center gap-3">
                    <input
                        type="checkbox"
                        id={airAlertCheckboxId}
                        {...register("airAlert")}
                        className="appearance-none relative block w-4 h-4 shrink-0
                        bg-[rgba(245,216,88,0.2)] border border-black cursor-pointer
                        checked:bg-black checked:border-black
                        after:absolute after:left-1/2 after:top-1/2
                        after:h-2 after:w-1 after:-translate-x-1/2 after:-translate-y-1/2
                        after:rotate-45 after:border-b-2 after:border-r-2
                        after:border-white after:opacity-0 checked:after:opacity-100"
                    />
                    <label
                        htmlFor={airAlertCheckboxId}
                        className="text-[12px] font-medium cursor-pointer select-none underline"
                    >
                        Підтверджую, що ознайомився(-лась) з Інформацією про порядок дій у разі оголошення сигналу  
                        <a href="/airalert" className="text-[#245864]" target="_blank" rel="noreferrer"> «Повітряна тривога»</a>
                        <span className="text-red-600">*</span>
                    </label>
                </div>
                

                <button type="submit" name="submit" className="relative submit-form 
                    font-extrabold text-[22px] text-[#245864] uppercase inline-flex items-center justify-between gap-3 cursor-pointer
                    bg-[#F5D858] py-2 pl-3 pr-4 w-full sm:max-w-[250px] hover:bg-[#F5D858]/60 transition-colors duration-300">
                    Надіслати
                </button>

                <input name="site_name" {...register("site_name")} type="hidden" value={domain}/>
                <input name="price" {...register("price")} type="hidden" value="1000"/>
                <input name="local" {...register("local")} type="hidden" value={isEn}/>
                <input name="utm_source" {...register("utm_source")} type="hidden" value={utm_source}/>
                <input name="utm_medium" {...register("utm_medium")} type="hidden" value={utm_medium}/>
                <input name="utm_campaign" {...register("utm_campaign")} type="hidden" value={utm_campaign}/>
                <input name="utm_content" {...register("utm_content")} type="hidden" value={utm_content}/>
                <input name="user_agent" {...register("user_agent")} type="hidden"/>
                <input name="user_ip" {...register("user_ip")} type="hidden"/>
                <input name="fbc" type="hidden" {...register("fbc")} />
                <input name="fbp" type="hidden" {...register("fbp")} />

                {/*<div>*/}
                {/*    <a href="https://forms.gle/Dnah485hScw5fTJT7"*/}
                {/*       target="_blank"*/}
                {/*       className="text-sm text-[#494D4E] hover:text-black w-full max-w-max font-normal py-2 inline-flex items-center cursor-pointer max-sm:col-span-2">Корпоративним*/}
                {/*        клієнтам</a>*/}
                {/*</div>*/}

                <div
                    className={"absolute top-0 left-0 w-full h-full d-flex items-center justify-center bg-white/90 text-[#003366] " + preloader}>
                    <div className="flex text-2xl justify-center items-center">
                        <FaRegCheckCircle className="mr-3"/>
                        <span>{waitText}</span>
                    </div>
                </div>
            </form>
            <p className="text-xs mb-2 max-md:mt-3 text-gray-600 max-w-[540px]">*Участь для УБД безкоштовна (за умови наявності посвідчення) </p>

            <a href="https://forms.gle/YqsE5QsZ9mWak6fv7" target="_blank"
                    className="text-[14px] font-medium underline md:block md:mb-0 hover:text-[#e8b500] transition-colors duration-300">Корпоративним клієнтам</a>

        </div>
    );
}
